<ion-router-outlet
  id="main-content"
></ion-router-outlet>
<app-menu></app-menu>